import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { EmailHistoryApi } from 'api';
import type { EmailHistory } from 'api/methods/EmailHistoryApi';

/**
 * [EmailHistory] Query key 생성
 * --
 */
export const emailHistoryQueryKeys = createQueryKeys('emailhistory', {
  getEmailHistory: (
    idx: number,
    params?: { [key: string]: string | number }
  ) => [idx, params],
  getEmailHistories: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [EmailHistory] 이메일 내역 전체 조회
 * --
 */
export const useGetEmailHistories = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: emailHistoryQueryKeys.getEmailHistories(params).queryKey,
    queryFn: () => EmailHistoryApi.getEmailHistories(params),
    ...options,
  });
  return data;
};

/**
 * [EmailHistory] 이메일 내역 상세 조회
 * --
 */
export const useGetEmailHistory = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: emailHistoryQueryKeys.getEmailHistory(idx, params).queryKey,
    queryFn: () => EmailHistoryApi.getEmailHistory(idx, params),
  });

  return data;
};

/**
 * [EmailHistory] 이메일 내역 생성
 * --
 */
export const useCreateEmailHistory = (body: EmailHistory) => {
  const { mutateAsync: createEmailHistory, ...result } = useMutation({
    mutationFn: (variables: EmailHistory) =>
      EmailHistoryApi.createEmailHistory(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createEmailHistory, ...result };
};

/**
 * [EmailHistory] 이메일 내역 수정
 * --
 */
export const useUpdateEmailHistory = (body: EmailHistory) => {
  const { mutateAsync: updateEmailHistory, ...result } = useMutation({
    mutationFn: (variables: EmailHistory) =>
      EmailHistoryApi.updateEmailHistory(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateEmailHistory, ...result };
};

/**
 * [EmailHistory] 이메일 내역 삭제
 * --
 */
export const useDeleteEmailHistory = (idx: number) => {
  const { mutateAsync: deleteEmailHistory, ...result } = useMutation({
    mutationFn: (variables: number) =>
      EmailHistoryApi.deleteEmailHistory(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteEmailHistory, ...result };
};
